// Declarative definitions of where items lie on the z-index
export const zIndex = {
	loader: 9,

	// The lights are directly below the header
	lights: 9,

	// The header is visible over the loader
	header: 10,

	// The mobile nav should fall over the header
	mobileNav: 12,

	// The cookie disclaimer should cover everything
	// except for the entry mask and modals
	cookiesDisclaimer: 97,

	// Context menu overlay goes directly under modals and
	// the menu itself
	contextMenuOverlay: 98,

	// Modals should cover mostly everything
	modals: 99,
	// The entry mask should generally cover everything
	entryMask: 100
};
